import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useState } from "react";
import { ApiRequestError } from "@/lib/api";
import { AuthProvider } from "./auth";
import { createAppRouter } from "./router";

export function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Erros de acesso (401/403/404) não adiantam repetir
            retry: (count, err) =>
              !(err instanceof ApiRequestError && err.status < 500) && count < 1,
            refetchOnWindowFocus: false,
            staleTime: 30_000,
          },
          // Mutações NUNCA são repetidas automaticamente: operações críticas usam
          // chave de idempotência e a repetição é decidida explicitamente.
          mutations: { retry: 0 },
        },
      }),
  );
  const [router] = useState(() => createAppRouter(queryClient));

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
